module.exports = __webpack_public_path__ + "static/img/55-ace-logo.1b78bcc3.png";